import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import InputGroup from 'react-bootstrap/InputGroup'
import { useState, useEffect } from 'react'
import { useToasts } from 'react-toast-notifications';
import moment from 'moment'

import './style.scss'

const Chargeback = ({ show=false, setShow, handleSuccess = () => ({}), activeUser }) => {
  const { addToast } = useToasts();

  const [date, setDate] = useState('')
  const [amount, setAmount] = useState('')
  const [errors, setErrors] = useState({})
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    console.log({activeUser})
  }, [activeUser])

  const handleSubmit = async () => {
    setBusy(true)
    await axios.post('/api/administration/chargebacks', {
      date,
      amount,
      id: activeUser.id
    })
    .then(res => {
      setDate('')
      setAmount('')
      handleSuccess()
      console.log(res)
      addToast('Chargeback successfully added', { appearance: 'success', autoDismiss: false });
      setShow(false)
    })
    .catch(err => {
      console.error(err); 
      addToast('Unable to add chargeback', { appearance: 'error', autoDismiss: false });
    }).finally(() => {
      setBusy(false)
    })
  }

  const handleDateBlur = (e) => {
    if (! date) {
      setErrors({
        ...errors,
        date: 'Date field is required'
      })
    }
  }
  
  const handleDateChange = (e) => {
    setErrors({ ...errors, date: ''});
    setDate(e.target.value);
    if (e.target.value == '') {
      setErrors({ ...errors, date: 'Please enter a valid date'})
    }
  }

  const handleOnblurAmount = (e) => {
    if (! amount) {
      setErrors({
        ...errors,
        amount: 'Amount field is required'
      })
    }
  }

  const handleAmountChange= (e) => {
    setErrors({ ...errors, amount: ''})
    setAmount(e.target.value)
    if (e.target.value <= 0) {
      setErrors({ ...errors, amount: 'Please enter a valid amount'})
    }
  }

  return <Modal
    show={show}
    onHide={() => setShow(false)}
    backdrop="static"
    keyboard={false}
    className="modal__chargeback"
  >
    <Modal.Header>
      <Modal.Title style={{fontSize: '16px', display: 'inline-block'}}>Add Chargeback for {activeUser.username}</Modal.Title>
    </Modal.Header>
    <Modal.Body style={{minHeight: 'auto'}}>
      <Form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6">
            <Form.Group className="mb-3" controlId="date">
              <Form.Label>Select Date</Form.Label>
              <Form.Control
                type="date"
                placeholder=""
                value={date}
                onChange={handleDateChange}
                onBlur={handleDateBlur}
                disabled={busy}
                isInvalid={errors.date}
              />
              <Form.Control.Feedback type="invalid">
                {errors.date}
              </Form.Control.Feedback>
            </Form.Group>
          </div>
          <div className={`col-md-6${errors.amount ? ' invalid':''}`}>
            <Form.Label>Amount</Form.Label>
            <InputGroup className="mb-2">
              <InputGroup.Text>
                <strong>USD $</strong>
              </InputGroup.Text>
                <Form.Control
                    type="number"
                    placeholder=""
                    value={amount}
                    onChange={handleAmountChange}
                    onBlur={handleOnblurAmount}
                    disabled={busy}
                    isInvalid={errors.amount}
                  />
              </InputGroup>

              <Form.Control.Feedback type="invalid">
                {errors.amount}
              </Form.Control.Feedback>
          </div>
        </div>
      </Form>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={() => setShow(false)}>
        Cancel
      </Button>
      <Button variant="primary" disabled={busy||errors.date||errors.amount||!date||!amount} onClick={handleSubmit}>Submit</Button>
    </Modal.Footer>
  </Modal>
}

export default Chargeback